import React, {useState} from "react";
import { GET_ONE, GET_LIST, SimpleForm, Create, Toolbar, SaveButton } from "react-admin";
import { Card, Button, CardContent } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from 'moment-timezone';
import {
  map,
  curry,
  range,
  filter,
  compose,
  isEmpty,
  prop,
  isNil
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import CustomDatePicker from "./customDatePicker";
import Select from "@material-ui/core/Select";
import { Link } from "react-router-dom";
import { parse } from "query-string";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import ReactExport from "react-export-excel";

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

import ReactExport from 'react-data-export';

import { API_ROOT } from "../api-config";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const StyledTableCell = styled(TableCell)`
  white-space: nowrap;
`;

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  centerAlignedCell: { textAlign: "center" },
  boldCell: { fontWeight: "bold" },
  widthTable: { 
    marginLeft: "30px",
    width: "50%"
  },
  flex: { display: "flex" },
};

let dataSetRentals = [];
let dataSetTours = [];
let dataSetToursGuided = [];
let dataSetOld = [];

const StartForm = styled.form({
  margin: "30px",
  display: "flex",
  flexDirection: "column",
  width: "30%",
//   height: "29rem",
  justifyContent: "space-between"
});

const useStyles = styled.div({
    backgroundColor: "transparent"
});
class ReportsMetrics extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        isLoading: true,
        numberOfMonths: 2,
        optDateBegin: null,
        optDateEnd: null,
        loading: false,
        showTables: false,
        setLoading: false,
        exportData: [],
        setExportData: [],
        DataSet: [],
        month: moment()
          .startOf("month")
          .format("YYYYMMDD")
      };
    }

    
  
    async componentDidMount() {
        moment_tz.tz.setDefault("Europe/Madrid");

        const startDate = moment()
            // .startOf("year")
            .format("YYYYMMDD");

        const endDate = moment()
            // .startOf("year")
            // .add(2, "month")
            .format("YYYYMMDD");

        await this.updateState(startDate, endDate, null, null, null);
      
    }
  
    updateState = async (
      startDate,
      endDate,
      optDateBegin,
      optDateEnd
    ) => {  
      const numberOfMonths = moment(endDate).diff(moment(startDate), "months");
  
      this.setState({
        numberOfMonths,
        isLoading: false,
        startDate,
        endDate,
        month: moment(startDate)
        //   .startOf("month")
          .format("YYYYMMDD"),
        optDateBegin,
        optDateEnd
      });
    };
  
    sortedDayList = (start, end) => {
      const add = (day, offset) => day.clone().add(offset, "days");
      return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
    };
  
    handleChangeOptE = eventDate => {
      this.setState({ optDateEnd: moment(eventDate) });
    };
  
    handleChangeOptB = eventDate => {
      this.setState({
        optDateBegin: eventDate
      });
  
      if (!isNil(eventDate) && isNil(this.state.optDateEnd)) {
        const newDate = moment(eventDate.format("YYYY-MM-DD")).add(1, "day");
        this.setState({
          optDateEnd: newDate
        });
      } else if (!isNil(this.state.optDateBegin) && !isNil(eventDate)) {
        if (moment(eventDate).isSameOrAfter(moment(this.state.optDateEnd))) {
          const newDate = moment(eventDate.format("YYYY-MM-DD")).add(1, "day");
          this.setState({
            optDateEnd: newDate
          });
        }
      }
    };

    handleChange = () => {
        dataSetRentals = [];
        dataSetTours = [];
        dataSetToursGuided = [];
        dataSetOld = [];
        if(this.state.optDateBegin !== null && this.state.optDateEnd !== null &&
          this.state.optDateBegin !== '' && this.state.optDateEnd !== '') {
            this.setState({ exportData: [], loading: true, showTables: true });
            this.getReports(this.state.optDateBegin.format("YYYY-MM-DD"), this.state.optDateEnd.format("YYYY-MM-DD"));
        }
      };

    async getReports(startDate, endDate, location) {
        
        const dataProvider = await dataProviderFactory("rest");
        const reportsMetrics = dataProvider(GET_LIST, "reports/metrics", {
        filter: {
            startDate: this.state.optDateBegin.format("YYYY-MM-DD"),
            endDate: this.state.optDateEnd.format("YYYY-MM-DD")
        },

        pagination: {
            page: 1,
            perPage: 99999
        },
        sort: { field: this.props.created_at, order: "DESC" }
        });

        reportsMetrics.then(async (result) => {
            this.state.loading = false;
            dataSetRentals = result.data.rentals;
            dataSetTours = result.data.tours;
            dataSetToursGuided = result.data.selfGuided;
            dataSetOld = result.data.dataOld;
            const dataSet = [{
                columns: [               
                    {title: "Value", style: {font: {sz: "14", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "C0C0C0"}}}, width: {wpx: 125}}, // width in pixels
                    {title: "Rental days", style: {font: {sz: "14", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "C0C0C0"}}}, width: {wpx: 125}}, // width in pixels
                    {title: "Num rentals", style: {font: {sz: "14", bold: true}, fill: {patternType: "solid", fgColor: {rgb: "C0C0C0"}}}, width: {wpx: 200}}, // width in pixels                    
                ],
                data: result.data.rentals.map((data) => [
                    {value: (data.value != null) ? new Intl.NumberFormat().format(data.value) : '', style: {font: {sz: "12"}}},
                    {value: (data.dayRentals != null) ? data.dayRentals : '', style: {font: {sz: "12"}}},
                    {value: (data.numRentals != null) ? data.numRentals : '', style: {font: {sz: "12"}}}
                ])
            }];

            this.setState({ loading: false, exportData: result.data.rentals, DataSet: dataSet });
            
            this.getReportsDownload(this.state.optDateBegin.format("YYYY-MM-DD"),
            this.state.optDateEnd.format("YYYY-MM-DD"));

            return result.data;
        })
        .catch((error) => {
            this.state.loading = false;
        });        
    }

    async getReportsDownload(startDate, endDate) {
      
      let data = {
        startDate: startDate,
        endDate: endDate
      };

      const response = await fetch(`${API_ROOT}/reports/download`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`,
        },
        body: JSON.stringify(data)
      });

      let commits = await response.json(); // read response body and parse as JSON

      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      // a.href = 'data:' + registro.mimeType + ';base64,' + registro.base64;
      a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${commits.data}`;
      a.download = `Metrics.xlsx`;
      a.click();
      a.remove();
    }
  
    render() {
      const {
        isLoading,
        month,
        optDateBegin,
        optDateEnd,
        numberOfMonths
      } = this.state;

      const { classes, ...props } = this.props;

      
  
      if (isLoading) {
        return (
          <Card>
            <LinearProgress />
          </Card>
        );
      }
  
      const startDate = month;
      const endDate = moment(month)
        // .add(numberOfMonths, "months")
        .format("YYYYMMDD");

        const PostCreateToolbar = props => <Toolbar {...props} style={{ backgroundColor: 'transparent' }}>
            <SaveButton label="Generate" onClick={this.handleChange}/>
            {/* {this.state.exportData.length !== 0 ? (
                    // <ExcelFile filename="Metrics" 
                    //   element={<SaveButton label="Download" style={{ marginLeft: '10px' }}/>}>
                    //   <ExcelSheet dataSet={this.state.DataSet} name="Metrics"/>
                    // </ExcelFile>
                    
                    ): null}     */}
        </Toolbar>;
  
      return (
        <Card>
            <StartForm>
                <h3>Reports Metrics</h3>
                <FormControl>
                <CustomDatePicker
                    onChange={e => this.handleChangeOptB(e)}
                    selectedDate={
                    optDateBegin && optDateBegin !== "null"
                        ? moment(optDateBegin).format("YYYY-MM-DD")
                        : null
                    }
                    label="Date Begin"
                    // minDate={moment(startDate)}
                    // maxDate={moment(endDate).format("YYYY-MM-DD")}
                />
                </FormControl>
                <FormControl>
                <CustomDatePicker
                    onChange={e => this.handleChangeOptE(e)}
                    selectedDate={
                    optDateEnd && optDateEnd !== "null"
                        ? moment(optDateEnd).format("YYYY-MM-DD")
                        : null
                    }
                    label="Date End"
                    // minDate={moment(optDateBegin).add(1, "day")}
                    // maxDate={moment(endDate).format("YYYY-MM-DD")}
                />
                </FormControl>                 
                <PostCreateToolbar />
            </StartForm>
            
            {this.state.showTables ? (
              <div style={styles.flex}>
                <Table style={styles.widthTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={3} style={styles.centerAlignedCell}>
                        <h3>RENTALS</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>                
                      <TableCell style={styles.centerAlignedCell}>Value</TableCell>
                      <TableCell style={styles.centerAlignedCell}>Day rentals</TableCell>
                      <TableCell style={styles.centerAlignedCell}> Num rentals</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  
                  {this.state.exportData.length === 0 ? (
                    this.state.loading ? (
                      <TableRow>
                        <TableCell colSpan={3}>
                          <LinearProgress />
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} style={styles.container}>
                          No hay Resultados...
                        </TableCell>
                      </TableRow>
                    )
                  ) : null}
                  {dataSetRentals.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={styles.centerAlignedCell}>
                        {new Intl.NumberFormat().format(item.value)}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.dayRentals}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.numRentals}
                      </TableCell>
                    </TableRow>
                  ))}
                  </TableBody>
                </Table>

                <Table style={styles.widthTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={2} style={styles.centerAlignedCell}>
                        <h3>TOURS</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>                
                      <TableCell style={styles.centerAlignedCell}>Value</TableCell>
                      <TableCell style={styles.centerAlignedCell}> Num tours</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  
                  {this.state.exportData.length === 0 ? (
                    this.state.loading ? (
                      <TableRow>
                        <TableCell colSpan={2}>
                          <LinearProgress />
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={2} style={styles.container}>
                          No hay Resultados...
                        </TableCell>
                      </TableRow>
                    )
                  ) : null}
                  {dataSetTours.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={styles.centerAlignedCell}>
                        {new Intl.NumberFormat().format(item.value)}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.numTours}
                      </TableCell>
                    </TableRow>
                  ))}
                  </TableBody>
                </Table>
                
                <Table style={styles.widthTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={2} style={styles.centerAlignedCell}>
                        <h3>SELF GUIDE</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>                
                      <TableCell style={styles.centerAlignedCell}>Value</TableCell>
                      <TableCell style={styles.centerAlignedCell}> Num tours</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  
                  {this.state.exportData.length === 0 ? (
                    this.state.loading ? (
                      <TableRow>
                        <TableCell colSpan={2}>
                          <LinearProgress />
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={2} style={styles.container}>
                          No hay Resultados...
                        </TableCell>
                      </TableRow>
                    )
                  ) : null}
                  {dataSetToursGuided.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={styles.centerAlignedCell}>
                        {new Intl.NumberFormat().format(item.value)}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.numTours}
                      </TableCell>
                    </TableRow>
                  ))}
                  </TableBody>
                </Table>
              </div>
            ) : null}   
            {this.state.showTables ? (
              <div style={styles.flex}>
                <Table style={styles.widthTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={4} style={styles.centerAlignedCell}>
                        <h3>RENTALS</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>                
                      <TableCell style={styles.centerAlignedCell}>Year</TableCell>
                      <TableCell style={styles.centerAlignedCell}>Value</TableCell>
                      <TableCell style={styles.centerAlignedCell}>Day rentals</TableCell>
                      <TableCell style={styles.centerAlignedCell}> Num rentals</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  
                  {this.state.exportData.length === 0 ? (
                    this.state.loading ? (
                      <TableRow>
                        <TableCell colSpan={4}>
                          <LinearProgress />
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} style={styles.container}>
                          No hay Resultados...
                        </TableCell>
                      </TableRow>
                    )
                  ) : null}
                  {dataSetOld.map((item) => (
                    <TableRow key={item.year}>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.year}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {new Intl.NumberFormat().format(item.rentals.value)}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.rentals.dayRentals}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.rentals.numRentals}
                      </TableCell>
                    </TableRow>
                  ))}
                  </TableBody>
                </Table>

                <Table style={styles.widthTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={3} style={styles.centerAlignedCell}>
                        <h3>TOURS</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>                
                      <TableCell style={styles.centerAlignedCell}>Year</TableCell>
                      <TableCell style={styles.centerAlignedCell}>Value</TableCell>
                      <TableCell style={styles.centerAlignedCell}> Num tours</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  
                  {this.state.exportData.length === 0 ? (
                    this.state.loading ? (
                      <TableRow>
                        <TableCell colSpan={3}>
                          <LinearProgress />
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} style={styles.container}>
                          No hay Resultados...
                        </TableCell>
                      </TableRow>
                    )
                  ) : null}
                  {dataSetOld.map((item) => (
                    <TableRow key={item.year}>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.year}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {new Intl.NumberFormat().format(item.tours.value)}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.tours.numTours}
                      </TableCell>
                    </TableRow>
                  ))}
                  </TableBody>
                </Table>

                <Table style={styles.widthTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={3} style={styles.centerAlignedCell}>
                        <h3>SELF GUIDE</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={styles.centerAlignedCell}>Year</TableCell>                
                      <TableCell style={styles.centerAlignedCell}>Value</TableCell>
                      <TableCell style={styles.centerAlignedCell}> Num tours</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  
                  {this.state.exportData.length === 0 ? (
                    this.state.loading ? (
                      <TableRow>
                        <TableCell colSpan={3}>
                          <LinearProgress />
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} style={styles.container}>
                          No hay Resultados...
                        </TableCell>
                      </TableRow>
                    )
                  ) : null}
                  {dataSetOld.map((item) => (
                    <TableRow key={item.year}>                    
                      <TableCell style={styles.centerAlignedCell}>
                        {item.year}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {new Intl.NumberFormat().format(item.selfGuided.value)}
                      </TableCell>
                      <TableCell style={styles.centerAlignedCell}>
                        {item.selfGuided.numTours}
                      </TableCell>
                    </TableRow>
                  ))}
                  </TableBody>
                </Table>
              </div>
            ) : null}
        </Card>
      );
    }
  }

  export default ReportsMetrics;


// WEBPACK FOOTER //
// ./src/components/reportsMetrics.js